/**
 * T30.9 · RESÍDUO DE TESTE NÃO É VITRINE. O relatório de 19/10 abriu a Biblioteca pública e o
 * primeiro cartão era «QA Ciclo da água». Quem testa marca o título («QA …», «(teste do QA, pode
 * apagar)»), e é essa marca que esconde o cartão das listas públicas — a biblioteca e o «Feito
 * aqui» da home. O documento continua no banco: apagar dado de produção é gesto do operador.
 */
const MARCAS = [/^\s*QA(?![\p{L}\d])/iu, /teste do QA/i, /pode apagar/i];

export function ehResiduoDeTeste(titulo: unknown): boolean {
  return typeof titulo === "string" && MARCAS.some((m) => m.test(titulo));
}
